<template>
  <div
    v-scroll="handleScrollPosition"
  >
    <div class="d-flex align-center">
      <v-btn
        :disabled="!$can('agent', 'createBuilding')"
        small
        class="primary ml-3"
        @click="$emit('detail', {id: null})"
      >
        <v-icon
          small
          class="mr-3"
        >mdi-plus
        </v-icon>
        Добавить дом
      </v-btn>
      <Controls
        :filters="value.requestParams.filters"
        @input="handleControls($event)"
      />
      <DeleteDialog
        v-if="$can('admin')"
        @update="debounceFillTable"
      />
    </div>
    <Table
      :options="value.requestParams.options"
      @input="localRequestParams.options = $event"
      :loading="loadingTable"
      :items="items"
      :items-length="itemsLength"
      @detail="$emit('detail', $event)"
      :opened.sync="localState.openedItems"
    />
  </div>
</template>

<script>
import Table from './List/Table'
import Controls from './List/Controls'
import list from '@/components/mixins/list'
import DeleteDialog from '@/components/views/admin/advert/List/DeleteDialog'

export default {
  mixins: [list],
  name: 'List',
  components: { Controls, Table, DeleteDialog },
  data () {
    return {
      fillTableUrl: '/building'
    }
  }
}
</script>

<style scoped>

</style>
